import constants from "../constants";

const {
  FILTER_LIST,
  FETCH_NEXT_LIST_TYPE_DONE,
} = constants;

function filters(state = {}, action) {
  switch (action.type) {
    case FETCH_NEXT_LIST_TYPE_DONE: {
      return {};
    }
    case FILTER_LIST: {
      return { ...action.data.filters };
    }
    default: {
      return state;
    }
  }
}

export default filters;


// WEBPACK FOOTER //
// ./assets/list/reducers/filters.js